import { useQuery } from "react-query";
import { CapacitorHttpAuth } from "./auth";
import { baseUrl } from "./api";

export const useGetMediaQuery = ({ id }: { id: string }) => {
  return useQuery({
    queryKey: ["getMedia"],
    queryFn: async () => {
      let response = await CapacitorHttpAuth({
        url: `${baseUrl}/driver/media/${id}`,
        method: "GET",
        responseType: "blob",
        headers: {
          accept: "image/jpeg",
        },
      });
      let res = response.data;

      return `data:image/jpeg;base64,${res}`;
    },
  });
};

export const getMedia = async ({ id }: { id: string }) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/media/${id}`,
    method: "GET",
    responseType: "blob",
    headers: {
      accept: "image/jpeg",
    },
  });

  if (response) {
    return `data:image/jpeg;base64,${response.data}`;
  } else {
    return null;
  }
};

export const createMedia = async ({ media }: { media: File }) => {
  let response = await CapacitorHttpAuth({
    url: `${baseUrl}/driver/media`,
    headers: {
      "content-type": "multipart/form-data",
    },
    method: "POST",
    data: {
      media,
    },
  });
  if (response.data) {
    return response.data as { id: string };
  }
  return;
};
